import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import { ref } from 'vue'
import { vMaska } from 'maska'
import { useTheme } from 'vuetify'
import VueDatePicker, { PartialTimeObj } from '@vuepic/vue-datepicker'
import { TextFieldDensity } from '../helpers'

interface Props {
  modelValue?: Date
  label?: string
  disable?: boolean
  loading?: boolean
  readonly?: boolean
  errorMessages?: string | readonly string[]
  density?: TextFieldDensity
  startTime?: PartialTimeObj | PartialTimeObj[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VDateFieldV2',
  props: {
    modelValue: {},
    label: { default: 'Дата' },
    disable: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    errorMessages: {},
    density: { default: 'default' },
    startTime: {}
  },
  setup(__props: any) {



const datePicker = ref()
const optsForMask = {
  mask: '##.##.####',
}

const toggleMenu = (isOpened: boolean) => {
  isOpened ? datePicker.value.closeMenu() : datePicker.value.openMenu()
}

const theme = useTheme()

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(_unref(VueDatePicker), {
    ref_key: "datePicker",
    ref: datePicker,
    "model-value": _ctx.modelValue,
    "text-input": {
      openMenu: false,
    },
    "enable-time-picker": false,
    clearable: false,
    dark: _unref(theme).global.name.value === 'dark',
    "start-time": _ctx.startTime,
    format: "dd.MM.yyyy",
    "auto-apply": "",
    locale: "ru-RU",
    position: "left",
    "enable-seconds": "",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:model-value', $event || undefined)))
  }, {
    "dp-input": _withCtx(({ value, onInput, onEnter, onClear, isMenuOpen }) => [
      _withDirectives((_openBlock(), _createBlock(_component_v_text_field, {
        "model-value": value,
        placeholder: "дд.мм.гггг",
        label: _ctx.label,
        loading: _ctx.loading,
        disable: _ctx.disable,
        readonly: _ctx.readonly,
        density: _ctx.density,
        onBlur: (e) => {
          onEnter(e)
          datePicker.value.formatInputValue()
          datePicker.value.parseModel()
        },
        onFocus: _cache[2] || (_cache[2] = ($event: any) => (toggleMenu(true))),
        "onUpdate:modelValue": onInput,
        onKeydown: _withKeys(onEnter, ["enter"]),
        "error-messages": _ctx.errorMessages,
        clearable: ""
      }, {
        "prepend-inner": _withCtx(() => [
          _createVNode(_component_v_icon, {
            icon: "mdi-calendar",
            onMouseup: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
            onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
            onClick: _withModifiers(($event: any) => (toggleMenu(isMenuOpen)), ["prevent","stop"])
          }, null, 8, ["onClick"])
        ]),
        clear: _withCtx(() => [
          _createVNode(_component_v_icon, {
            icon: "mdi-close-circle",
            onClick: onClear
          }, null, 8, ["onClick"])
        ]),
        _: 2
      }, 1032, ["model-value", "label", "loading", "disable", "readonly", "density", "onBlur", "onUpdate:modelValue", "onKeydown", "error-messages"])), [
        [_unref(vMaska), void 0, optsForMask]
      ])
    ]),
    _: 1
  }, 8, ["model-value", "dark", "start-time"]))
}
}

})